module.exports = __webpack_public_path__ + "./timer-worker2.js";


//////////////////
// WEBPACK FOOTER
// ./~/file-loader?name=./timer-worker2.js!./src/core/services/data/timer-worker.js
// module id = 2511
// module chunks = 0